<template>
    <div class="login">
        <b-container class="login_box" id="box_adapter">
            <b-row v-if="!finished" style="height: 100%;">
                <b-col id="box_login" cols="12" lg="7">
                    <b-row>
                        <b-col>
                            <br>
                            <br>
                            <br>
                            <h1>Cambio Password</h1>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" offset-md="1" md="9">
                            <br>
                            <br>
                            <br>
                            <b-input-group>
                                <b-input-group-prepend class="icon_form" is-text>
                                    <font-awesome-icon icon="user" />
                                </b-input-group-prepend>
                                <b-form-input class="input_form" v-model="email" size="lg" type="text" placeholder="Email"></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" offset-md="1" md="9">
                            <br>
                            <b-input-group>
                                <b-input-group-prepend class="icon_form" is-text>
                                    <font-awesome-icon icon="key" v-on:click="toggleSecure()" />
                                </b-input-group-prepend>
                                <b-form-input class="input_form" v-model="password" size="lg" :type="secure" placeholder="Nuova Password" v-on:keyup.enter="onSubmit()"></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" offset-md="1" md="9">
                            <br>
                            <b-input-group>
                                <b-input-group-prepend class="icon_form" is-text>
                                    <font-awesome-icon icon="key" v-on:click="toggleSecure()" />
                                </b-input-group-prepend>
                                <b-form-input class="input_form" v-model="repassword" size="lg" :type="secure" placeholder="Ripeti Password" v-on:keyup.enter="onSubmit()"></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-row>                    
                    <b-row>
                        <b-col>
                            <br>
                            <b-link style="border-bottom: 3px solid #eff5f3;" v-on:click="goTo('/login')">Torna al login</b-link>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <br>
                            <b-button id="button_form" v-on:click="onSubmit()">INVIA</b-button>
                            <br>
                            <br>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <h5 style="margin: 0">Alcuni dei nostri partner:</h5>
                            <img style="margin: 15px" height="70" :src="require('@/assets/images/cardin_logo.jpg')" />
                            <img style="margin: 15px" height="70" :src="require('@/assets/images/csd.png')" />
                            <br>
                            <img style="margin: 15px; margin-top: 0" height="35" :src="require('@/assets/images/DFM.jpg')" />
                        </b-col>
                    </b-row>
                </b-col>
                <b-col id="box_laterale" cols="12" lg="5">
                    <b-row>
                        <b-col>
                            <h1>Istruzioni</h1>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>        
                            <img width="300" height="140" :src="require('@/assets/images/marchio.png')" />
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col offset="2" cols="8">
                            <br>
                            <h4>Inserisci la tua email, scegli una nuova password e ripetila per confermarla, ti verrà inviata un'email con un link, clicca sul link per confermare il cambio password.</h4>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col v-if="registrazione" id="box_type_user" cols="12" lg="7">
                    <b-row>
                        <b-col>
                            <br>
                            <br>
                            <br>
                            <h1>Sei un:</h1>
                        </b-col>
                    </b-row>
                    <b-row style="padding-top: 10%;">
                        <b-col cols="12" lg="6">
                            <br>
                            <b-button class="button_type_user" v-on:click="registrazioneInstallatore()">
                                <b-row>
                                    <b-col>
                                        <font-awesome-icon class="icon_type_user" icon="user-cog" />
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col>Installatore</b-col>
                                </b-row>
                            </b-button>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <br>
                            <b-button class="button_type_user" v-on:click="registrazioneConsulente()">
                                <b-row>
                                    <b-col>
                                        <font-awesome-icon class="icon_type_user" icon="user-tie" />
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col>Consulente</b-col>
                                </b-row>
                            </b-button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>


            <b-row v-if="finished" id="fine">
                <b-col>
                    <h2>Richiesta effettuata con successo</h2>
                    <br>
                    <b-col offset-lg="1" lg="10"><h4>Riceverai un'email con un link di verifica, clicca sul link per confermare il cambio password.</h4></b-col>
                    <b-link style="border-bottom: 3px solid #eff5f3;" v-on:click="goTo('/login')">Torna al login</b-link>
                    <br>
                </b-col>
            </b-row>
        </b-container>

    </div>
</template>

<script>
import Vue from 'vue'

export default {    
    data() {
        return {
            login: true,
            email: "",
            password: "",
            repassword: "",
            finished: false,
            secure: 'password'
           }
    },
    methods: {
        onSubmit() {
            if (this.password !== this.repassword){
              Vue.notify({
                  group: 'global',
                  title: 'Verifica password',
                  text: 'Il campo password e il campo ripeti password non corrispondono',
                  type: 'error'
              })   
              return;           
            }
            Vue.http.post('user/resetPassword', {email: this.email, password: this.password, repassword: this.repassword}, {credentials : true}).then(response => {
                if(response.body.success){
                    Vue.notify({
                        group: 'global',
                        title: 'Richiesta effettuata',
                        text: 'Vai nella tua email e clicca il link di conferma!',
                        type: 'success'
                    })
                    this.finished = true;
                }
            }, response => {
                Vue.notify({
                    group: 'global',
                    title: 'Errore!',
                    text: 'Qualcosa è andato storto!',
                    type: 'error'
                })
            })
        },
        goTo(path){
            this.$router.push(path)
        },
        toggleSecure(){
          if (this.secure === "password"){
            this.secure = "text";
          }else{
            this.secure = "password";
          }
        }
    }
}
</script>

<style scoped>
.login{
    position: relative;
    overflow: hidden;
    padding-top: 10vh;
    padding-bottom: 20px;
    background: #f0f4f3;
    height: 100vh;
}

.login_box{
    position: relative;
    height: 80vh;
    max-height: 900px;
    background: white;
    border-radius: 15px;
    overflow: hidden;

    -webkit-box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.5);
    -moz-box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.5);
    box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.5);
    z-index: 1;
}

#box_login{
    color: #493240;
    text-align: center;
}

#box_laterale{
    background: #493240;
    color: white;
    text-align: center;
    padding: 0;
    padding-top: 20%;
}

#box_type_user{
    color: #493240;
    text-align: center;
    margin-bottom: 20px;
}

.input_form{
    background-color: #f4f6f8 !important;
    border: 0 !important;
    height: 60px !important;
    border-top-left-radius: 0.3rem !important;
    border-bottom-left-radius: 0.3rem !important;
}

.icon_form div{
    background-color: transparent !important;
    border: 0;
}

#button_form{
    background-color: #493240;
    font-size: 25px;
    padding: 15px 100px;
    border-radius: 30px;
    border-color: white;
}

.button_close_registrazione{
    margin-top: 15px;
}

.button_type_user{
    background-color: white;
    color: #493240;
    width: 100%;
    font-size: 20px;
    text-align: center;
    padding: 35px;
    border-radius: 20px;
    border-color: #493240;
}

.button_type_user:hover{
    background-color: #493240;
    color: white;
}

.icon_type_user{
    font-size: 100px;
    margin-bottom: 20px;
}

#fine{
    color: #493240;
    text-align: center;
    padding-top: 10%;
}

#search_box{
  width: 60%;
  margin-top: 10px;
  margin-left: 20px;
}

#ubicazione_map{
  width: 100%;
  height: 400px;
  border-radius: 4px;

  -webkit-box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.5);
  -moz-box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.5);
  box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.5);
}

#logo_box{
    position: relative;
    width: 80%;
    height: 200px;
    z-index: 1;
    margin-left: 10%;
    margin-right: 10%;
}

#logo_box > div > div > img{
    border-radius: 2px;
    margin-top: 10px;
    margin-left: 10px;

    -webkit-box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.5);
    -moz-box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.5);
    box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.5);
}

#ball1{
    position: fixed;
    top: 65vh;
    left: -100px;
    width: 500px;
    height: 500px;
    background: #493240;
    z-index: 0;
    border-radius: 500px;
}

#ball2{
    position: fixed;
    top: -100px;
    right: -100px;
    width: 500px;
    height: 500px;
    background: #493240;
    z-index: 0;
    border-radius: 500px;
}

@media only screen and (max-width: 991px) {
    .login_box{
        height: auto !important;
        max-height: none !important;
    }

    .login{
        overflow-y: auto;
    }

    #search_box{
        width: calc(60% - 60px);
    }
}

@media only screen and (max-width: 768px) {
    #search_box{
        margin-top: 60px;
        margin-left: 0;
    }
}

@media only screen and (max-width: 576px) {
    .login{
        padding: 0;
    }

    .login_box{
        border-radius: 0;
        height: 100vh;
        min-height: 100vh;
        overflow-y: auto;
        overflow-x: hidden;
    }
}

@media only screen and (max-height: 850px) and (min-width: 992px) {  
  #box_adapter{
    height: auto !important;
    max-height: none !important;
  }

  .login{
    overflow-y: auto;
  }
}

#denominazione{
  text-indent: 150px;
}

#piva{
  text-indent: 120px;
}

#cf{
  text-indent: 135px;
}

#email{
  text-indent: 85px;
}

#num_installatori{
  text-indent: 200px;
}

#cod_attivazione{
  text-indent: 180px;
}

#website{
  text-indent: 95px;
}

#cellulare{
  text-indent: 95px;
}

#telefono{
  text-indent: 95px;
}

#fax{
  text-indent: 60px;
}

#note{
  text-indent: 70px;
  line-height: 1.8;
}

#durc_scadenza{
  text-indent: 100px;
}

#visura_camerale_scadenza{
  text-indent: 100px;
}

#codiceConsulente{
  text-indent: 180px;
}
</style>
